export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/globant/site/src/environments/environment.ts